import { LinkedinFeedPeriod } from "@/app/types/prospect/LinkedinFeedPeriod";

const MEMBER_URN_PATTERN = /ACoAA[A-Za-z0-9_-]+/;

export class ULinkedinFeed {
  private static readonly SEARCH_URL = "https://www.linkedin.com/search/results/content/";

  public static memberUrn(externalId: string | null | undefined): string | null {
    return externalId?.match(MEMBER_URN_PATTERN)?.[0] ?? null;
  }

  public static buildUrl(members: string[], period: LinkedinFeedPeriod): string {
    const params = new URLSearchParams({
      origin: "FACETED_SEARCH",
      sortBy: JSON.stringify(["date_posted"]),
      datePosted: JSON.stringify([period]),
      fromMember: JSON.stringify(members),
    });

    return `${ULinkedinFeed.SEARCH_URL}?${params.toString()}`;
  }
}
